import styled from 'styled-components';

export const ReportSectionList = styled.div`
  > label {
    padding-right: 0;
    padding-left: 0;
    height: 60px;

    > span {
      font-size: 15px;
    }

    &::after {
      width: 100%;
      background-color: ${({ theme }) => theme.colors.border.primary};
    }
  }
`;
